import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRedirectGuard = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // リアルタイムでの管理者認証チェック
  const checkAdminAuth = () => {
    const adminToken = localStorage.getItem('admin_token');
    const adminUser = localStorage.getItem('admin_user');
    const isIntegratedAdmin = user && user.user_type === 'admin';

    console.log('AdminRedirectGuard - Real-time auth check:', {
      adminToken: !!adminToken,
      adminUser: !!adminUser,
      isIntegratedAdmin,
      path: location.pathname
    });

    return (adminToken && adminUser) || isIntegratedAdmin;
  };

  useEffect(() => {
    // localStorage の変更を監視
    const handleStorageChange = () => {
      const isAdmin = checkAdminAuth();
      if (isAdmin) {
        console.log('AdminRedirectGuard: Admin detected via storage change, should redirect');
      }
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, [user, location]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // 管理者認証の即座チェック
  const isAdminAuthenticated = checkAdminAuth();

  console.log('AdminRedirectGuard - Final check:', {
    isAdminAuthenticated,
    currentPath: location.pathname,
    user: user,
    shouldRedirect: isAdminAuthenticated
  });

  // /admin-login ページの場合はリダイレクトしない（ログアウト等でアクセスする場合があるため）
  if (location.pathname === '/admin-login') {
    console.log('AdminRedirectGuard: On admin login page, allowing access');
    return children;
  }


  // 管理者の場合は即座にリダイレクト（トップページを除く）
  if (isAdminAuthenticated) {
    console.log('AdminRedirectGuard: Admin authenticated, redirecting to admin dashboard');
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default AdminRedirectGuard;